module.exports = __webpack_public_path__ + "media/img/youtube-play-e6f0c233c87ddefab049c991c61e2d69.png";